export { default } from "./IndustryProfessional";
